export default __webpack_public_path__ + "static/media/7 aadil.9e7277ac.png";